module.exports = __webpack_public_path__ + "static/media/image (20).40e80ce3.jpg";